import { render, staticRenderFns } from "./showRich.vue?vue&type=template&id=32314aab&scoped=true"
import script from "./showRich.vue?vue&type=script&lang=js"
export * from "./showRich.vue?vue&type=script&lang=js"
import style0 from "./showRich.vue?vue&type=style&index=0&id=32314aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32314aab",
  null
  
)

export default component.exports